/**
 * RTWO Indexer Engine — Null Storage Adapter
 */

import type { RTWOIndexQueryType, RTWOIndexType } from '../domain-models';
import type {
  IStorageAdapter,
  QueryAdapterResult,
  SearchAdapterResult,
  StorageAdapterStatus,
} from './storage-adapter-interface';

export class NullStorageAdapter implements IStorageAdapter {
  readonly adapterId = 'null-storage-adapter';
  readonly adapterName = 'Null Storage Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): StorageAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async executeQuery(
    _queryType: RTWOIndexQueryType,
    _queryText: string
  ): Promise<QueryAdapterResult | null> {
    return null;
  }

  async search(_searchText: string): Promise<SearchAdapterResult | null> {
    return null;
  }

  async searchByType(
    _indexType: RTWOIndexType,
    _searchText: string
  ): Promise<SearchAdapterResult | null> {
    return null;
  }
}
